import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';

import { citiesApiQuery } from '../../mockQuery';

import { ListRequest } from './types';

const tagTypes = ['Cities'];

export const citiesApi = createApi({
  tagTypes,
  reducerPath: 'citiesApi',
  baseQuery: citiesApiQuery,
  endpoints: (build) => ({
    list: build.query<string[], ListRequest>({
      providesTags: tagTypes,
      query: (data) => ({
        data,
        method: 'get',
        url: URL.GET_CITIES,
      }),
    }),
  }),
});

export const { useListQuery } = citiesApi;
